import { useActiveSession } from '@texas/hooks/useSession';
import { BodyOverride } from '../shared/BodyOverride';
import { useWidgetLayout, WidgetOption } from '../widgets/useWidgetLayout';
import { TableColumns } from './TableColumns';
import { defaultDashboardWidgetsLayout } from './defaultDashboardWidgetsLayout';
import {
  defaultArticlesWidgetOptions,
  pageSize,
} from './defaultWidgetsOptions';
import { Flex } from '@chakra-ui/react';
import { WidgetType } from '../widgets/shared/types';
import { PaTableColumns } from './PaTableColumns';
import { useMemo } from 'react';
import { DashboardToolbar } from './DashboardToolbar';
import { NewCustomer } from '../customer/newCustomer/NewCustomer';
import { NewConcept } from '../customer/newConcept/NewConcept';
import { CopyArticleButton } from '../article/copy/CopyArticleButton';
import { CreateArticleButton } from '../article/create/CreateArticleButton';
import { Role } from '@texas/api/endpoints/userApi';
import { RoleRestrict } from '../shared/RoleRestrict';

export function Dashboard() {
  const session = useActiveSession();
  const widgetOptions = useMemo<WidgetOption>(
    () => ({
      [WidgetType.Articles]: {
        type: WidgetType.Articles,
        ...defaultArticlesWidgetOptions(session.currentUser),
        localStorageKey: `${session.currentUser.id}_${WidgetType.Articles}`,
        columns: TableColumns,
        optOutDefaultOrdering: true,
        pageSize: pageSize,
      },
      [WidgetType.ArticlesCount]: {
        type: WidgetType.ArticlesCount,
        ...defaultArticlesWidgetOptions(session.currentUser),
        localStorageKey: `${session.currentUser.id}_${WidgetType.Articles}`,
        columns: TableColumns,
        optOutDefaultOrdering: true,
      },
      [WidgetType.ProductApprovalsCount]: {
        type: WidgetType.ProductApprovalsCount,
        ...defaultArticlesWidgetOptions(session.currentUser),
        localStorageKey: `${session.currentUser.id}_${WidgetType.ProductApprovalsCount}`,
        columns: PaTableColumns,
        optOutDefaultOrdering: true,
      },
      [WidgetType.PaRejectionReasons]: {
        type: WidgetType.PaRejectionReasons,
      },
    }),
    [session.currentUser],
  );

  const { widgetComponents, addNewWidget, widgets, layout, setLayout } =
    useWidgetLayout({
      localStorageKey: `${session.currentUser.id}_dashboard`,
      defaultLayout: defaultDashboardWidgetsLayout,
      board: 'Dashboard',
      widgetOptions,
    });

  return (
    <BodyOverride>
      <Flex flexDir="column" gap={2}>
        <Flex className="dashboard-actions">
          <NewCustomer buttonProps={{ variant: 'entityDirectorySecondary' }} />
          <NewConcept buttonProps={{ variant: 'entityDirectorySecondary' }} />
          <RoleRestrict
            allow={[Role.InternalAdministrator, Role.SystemAdministrator]}
          >
            <CreateArticleButton />
            <CopyArticleButton variant="entityDirectorySecondary" />
          </RoleRestrict>
          <DashboardToolbar
            board="Dashboard"
            currentWidgets={widgets}
            onAdd={(type, name, color, options) =>
              addNewWidget(type, name, color, options)
            }
            layout={layout}
            setLayout={setLayout}
            widgetOptions={widgetOptions}
            defaultLayout={defaultDashboardWidgetsLayout}
          />
        </Flex>
        {widgetComponents}
      </Flex>
    </BodyOverride>
  );
}
